class LqdPfSingleRelatedHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initCarousel();

  }

  getDefaultSettings() {
    return {
      selectors: {
        carouselElement: '[data-lqd-flickity]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $carouselElement: this.$element.find(selectors.carouselElement),
    }
  }

  initCarousel() {

    this.elements.$carouselElement.liquidCarousel({
      bypassCheck: true
    });

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdPfSingleRelatedHandler, { $element } );
};